import React from "react";
import TeamSettingSidebarSidepanel from "./TeamSettingSidebarSidepanel";
import TeamSettingSidebarHeader from "./TeamSettingSidebarHeader";
import TeamSettingSidebarContent from "./TeamSettingSidebarContent";
import "./TeamSettingSidebar.scss";

/**
 * Team settings slide-out shell: icon rail + header + scrollable PanelBar content.
 * @author Bhavana
 */
const TeamSettingSidebar = () => {
  return (
    <div className="team-setting-sidebar-container position-relative d-flex h-100 w-100" id="team-setting-sidebar">
      <div className="sidepanel-container border-left border-right bg-light">
        <TeamSettingSidebarSidepanel />
      </div>
      <div className="sidebar-right-container flex-grow-1 d-flex flex-column bg-white">
        <div className="sidebar-header flex-shrink-0">
          <TeamSettingSidebarHeader />
        </div>
        <div className="sidebar-content flex-grow-1 overflow-y-auto overflow-x-hidden">
          <TeamSettingSidebarContent />
        </div>
      </div>
    </div>
  );
};

export default TeamSettingSidebar;
